import { render } from "./ConfOwner.vue?vue&type=template&id=1314847c"
import script from "./ConfOwner.vue?vue&type=script&lang=js"
export * from "./ConfOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__